import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationCircle } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { BaremetalCommand } from '../../@types/launch';
import { Endpoints } from '../../apis';
import { getErrorMessage } from '@xver/utils/error';

interface Vars {
    id: number;
    command: BaremetalCommand;
}

export function useSendBaremetalCommandMutate() {
    const { t } = useTranslation('notifications');
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, command }: Vars) => Endpoints.v1.Baremetals.sendCommand(id, command),
        onSuccess: (_data, vars) => {
            queryClient.invalidateQueries({ queryKey: ['api.v1.baremetals.list'] });
            queryClient.invalidateQueries({ queryKey: ['api.v1.baremetals.get'] });
            notifications.show({
                title: t('baremetal.commandSentTitle'),
                message: t('baremetal.commandSentMessage', { command: vars.command }),
                icon: <IconCheck size={32} color={'#00ff00'} />,
            });
        },
        onError: (error: any) => {
            notifications.show({
                title: t('baremetal.commandFailedTitle'),
                message: getErrorMessage(error),
                icon: <IconExclamationCircle size={32} color={'#eb5757'} />,
            });
        },
    });
}
